"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var shared_1 = require("@formily/shared");
var context_1 = require("../context");
exports.useArrayList = function (index) {
    if (index === void 0) { index = 0; }
    var _a = react_1.useContext(context_1.ArrayContext), value = _a.value, disabled = _a.disabled, editable = _a.editable, minItems = _a.minItems, maxItems = _a.maxItems, renders = _a.renders, props = __rest(_a, ["value", "disabled", "editable", "minItems", "maxItems", "renders"]);
    var renderWith = function (name, render, wrapper) {
        var children;
        if (renders && renders[name]) {
            if (shared_1.isFn(renders[name]) || renders[name].styledComponentId) {
                children = renders[name](context.currentIndex);
            }
            else {
                children = render(renders[name]);
            }
        }
        else {
            children = render(renders[name]);
        }
        if (shared_1.isFn(wrapper)) {
            return wrapper(__assign(__assign({}, context), { children: children })) || react_1.default.createElement(react_1.Fragment, null);
        }
        return children || react_1.default.createElement(react_1.Fragment, null);
    };
    var newValue = shared_1.toArr(value);
    var isEmpty = !newValue || (newValue && newValue.length <= 0);
    var isDisable = disabled || editable === false;
    var allowMoveUp = newValue && newValue.length > 1 && !isDisable;
    var allowMoveDown = newValue && newValue.length > 1 && !isDisable;
    var allowRemove = shared_1.isNum(minItems)
        ? newValue.length > minItems && !isDisable
        : !isDisable;
    var allowAddition = shared_1.isNum(maxItems)
        ? newValue.length < maxItems && !isDisable
        : !isDisable;
    var context = __assign(__assign({}, props), { currentIndex: index, isEmpty: isEmpty,
        isDisable: isDisable,
        allowRemove: allowRemove,
        allowAddition: allowAddition,
        allowMoveDown: allowMoveDown,
        allowMoveUp: allowMoveUp,
        renderWith: renderWith });
    return context;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react-shared-components/lib/hooks/useArrayList.js
// module id = 4670
// module chunks = 0